// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Open Sans', 'Open Sans Fallback'"},"className":"__className_87444c"};